export const aiQueryKeys = {
  all: ['ai'] as const,
  threads: () => [...aiQueryKeys.all, 'threads'] as const,
  thread: (id: string) => [...aiQueryKeys.all, 'threads', id] as const,
  threadMessages: (id: string) => [...aiQueryKeys.all, 'threads', id, 'messages'] as const,
  explain: (p: { pluginId: string; entityType: string; entityId: string; field: string }) =>
    [...aiQueryKeys.all, 'explain', p.pluginId, p.entityType, p.entityId, p.field] as const,
  insightCard: (p: { pluginId: string; entityType: string; entityId: string }) =>
    [...aiQueryKeys.all, 'insightCard', p.pluginId, p.entityType, p.entityId] as const,
  feedback: (q: { targetKind: 'chat_message' | 'inline_card' | 'insight'; threadId?: string; messageId?: string; pluginId?: string; entityType?: string; entityId?: string }) =>
    [...aiQueryKeys.all, 'feedback', q.targetKind, q.threadId, q.messageId, q.pluginId, q.entityType, q.entityId] as const,
  notesByEntity: (p: { pluginId: string; entityType: string; entityId: string }) =>
    [...aiQueryKeys.all, 'notes', p.pluginId, p.entityType, p.entityId] as const,
  insightsList: (q: Record<string, unknown>) => ['insights', 'list', q] as const,
  bundles: (q: Record<string, unknown> = {}) => [...aiQueryKeys.all, 'bundles', q] as const,
  bundle: (id: string) => [...aiQueryKeys.all, 'bundle', id] as const,
  pendingApprovals: () => [...aiQueryKeys.all, 'pendingApprovals'] as const,
  workflowRun: (workflowRunId: string) =>
    [...aiQueryKeys.all, 'workflowRun', workflowRunId] as const,
  workflows: () => [...aiQueryKeys.all, 'workflows'] as const,
};
